import { Control, Controller } from "react-hook-form";

import { ICreateCompanyForm } from "../CompanyForm";
import { CompanyTypeSelect } from "../Selects";
import { FormLabel } from "@ui/FormElements";

interface ICompanyTypeFormFieldProps {
  control: Control<ICreateCompanyForm>;
  options: any[];
  onSave?: (value: any) => void;
}

export function CompanyTypeFormField({ control, options, onSave }: ICompanyTypeFormFieldProps) {
  return (
    <Controller
      control={control}
      name="type"
      render={({ field: { value, onChange } }) => (
        <div className="flex flex-col justify-between gap-0.5">
          <FormLabel htmlFor="type">Company Type</FormLabel>
          <div className="w-full">
            <CompanyTypeSelect
              options={options}
              value={value}
              onChange={(option) => {
                onChange(option);
                onSave?.(option);
              }}
              className="w-full"
            />
          </div>
        </div>
      )}
    />
  );
}
